import { ColumnHelper } from "PFComponents/table/table.types";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";

import { isOpenVacancyItem, SuggestedWmTableItem } from "../types";
import { OpenVacancy } from "./open_vacancy";
import { SuggestedWmCell } from "./suggested_wm_cell";

const SUGGESTED_WM_COLUMN_WIDTH = 200;

export const createSuggestedWmColumn = (
  columnHelper: ColumnHelper<SuggestedWmTableItem>,
  headerLabel: string
) =>
  columnHelper.accessor(
    (row) => (isOpenVacancyItem(row) ? undefined : getProfileName(row.profile) || undefined),
    {
      id: "suggestedWm",
      header: () => (
        <Typography withMargin variant="labelRegular">
          {headerLabel}
        </Typography>
      ),
      cell: (info) => {
        const item = info.row.original;
        if (isOpenVacancyItem(item)) {
          return <OpenVacancy />;
        }
        return <SuggestedWmCell shortlist={item} />;
      },
      size: SUGGESTED_WM_COLUMN_WIDTH,
      sortFn: (rowA, rowB) => {
        const nameA = isOpenVacancyItem(rowA.original)
          ? ""
          : (getProfileName(rowA.original.profile)?.toLowerCase() ?? "");
        const nameB = isOpenVacancyItem(rowB.original)
          ? ""
          : (getProfileName(rowB.original.profile)?.toLowerCase() ?? "");
        return nameA.localeCompare(nameB);
      },
      sortDescFirst: false,
      sortUndefined: "last"
    }
  );
